"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.skipWhileRecipe = void 0;
const prepare_1 = require("../types-internal/prepare");
function skipWhileRecipe({ filter, resolver }) {
    return function (baseCondition) {
        let found = false;
        const condition = (0, prepare_1.prepare)(baseCondition);
        return filter.call(this, (t) => resolver(condition(t), (r) => (found = found || !r)));
    };
}
exports.skipWhileRecipe = skipWhileRecipe;
